<template>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.2.1/css/all.min.css">

  <div dir="rtl">


    <div>
      <div :class="isModalVisible == true || isModalReferral == true || isModalPishnahad == true ? 'custom' : ''" id="nav"
        v-if="isMobile == true && ($route.path == '/imagegeneration' || $route.path == '/' || $route.path == '/Gallery' || $route.path == '/characters' || $route.path == '/conversations')"
        class="mobileRoomTopNav_3gjO3" style="border-radius: 0 0 20px 20px;">
        <div class="content_1QLZB" id="topnav">
          <div class="right_1XMld">

            <h3 style="color:white;margin-right: 20px;font-weight: bold;font-family: IRANSansWeb;"
              class="pageTitle_36g65">{{ this.$route.name }}</h3>

          </div>
          <div style="margin-left:20px;" class="left_3cl7J">
            <div  v-if="showPromotion == true" @click="gotoPromotion()"
              style="box-shadow:0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.12));display:flex;margin-top:5px;margin-bottom:5px;height:2.5em;margin-left:10px;text-align: center;border-radius: 30px;padding:5px;background: rgb(218, 45, 45);background: linear-gradient(90deg, rgb(228, 51, 51) 20%, #fd7691 100%);">
              <i class="fa-solid fa-gift"
                style="margin-right: 3px;margin-left:3px;font-size:13px;padding: 5px;color:white"></i>
              <h3 id="timer" style="margin-top:4px;color:white;font-weight: bold;font-family: IRANSansWeb;font-size:15px"
                class="pageTitle_36g65"></h3>
            </div>
            <div v-if="showPromotion == false && showCookie == true" @click="isModalVisible = true"
              style="box-shadow:0px 3px 1px -2px var(--v-shadow-key-umbra-opacity, rgba(0, 0, 0, 0.2)), 0px 2px 2px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.14)), 0px 1px 5px 0px var(--v-shadow-key-penumbra-opacity, rgba(0, 0, 0, 0.12));display:flex;margin-top:5px;margin-bottom:5px;height:2.5em;margin-left:10px;text-align: center;border-radius: 30px;padding:5px;background: rgb(97,83,204);background: linear-gradient(90deg, rgb(106, 94, 202) 20%, #fd7691 100%);">
              <i class="fa-solid fa-plus"
                style="margin-right: 3px;margin-left:3px;font-size:15px;padding: 5px;color:white"></i>
              <h3 style="margin-top:4px;color:white;font-weight: bold;font-family: IRANSansWeb;font-size:17px"
                class="pageTitle_36g65">{{ this.userInfo.credit > 1000 ? 'نامحدود' : this.userInfo.credit }} 🍪</h3>
            </div>
            
            <v-menu v-if="this.isMobile" id="menuu" :location="'bottom right'">
              <template v-slot:activator="{ props }">
                <v-btn @click="test()" color="#6153cc" dark v-bind="props" style="min-width: 0px !important;">
                  <i id="menubar" class="fa-solid fa-bars" style="font-size: 20px;"></i>
                </v-btn>
              </template>
              <v-theme-provider with-background>

                <v-card id="menuuu" min-width="100">

                  <v-list>

                    <v-list-item>
                      <template v-slot:append>
                        <a class="btn btn-md btn-primary" style="width: 154px;">{{ this.mobile }}</a>

                      </template>
                    </v-list-item>
                    <v-list-item>
                      <template v-slot:append>
                        <a @click="gotoPackages()" style="width: 154px;" class="btn btn-md btn-primary">🍪خرید کوکی<i style="margin-left:5px" class="fa-solid fa-shopping-basket"></i></a>

                      </template>
                    </v-list-item>
                    <v-list-item>
                      <template v-slot:append>
                        <a @click="this.isModalReferral = true" style="width: 154px;" class="btn btn-md btn-primary">دعوت
                          دوستان<i style="margin-left:5px" class="fa-regular fa-envelope"></i></a>

                      </template>
                    </v-list-item>
                    <v-list-item>
                      <template v-slot:append>
                        <a @click="showPoshtibani()" id="testbutton" style="width: 154px;"
                          class="btn btn-md btn-primary testbutton">پشتیبانی آنلاین<i style="margin-left:5px" class="fa-solid fa-headset"></i><span id="unread_message" style="margin-right:5px;padding: 3px 10px;border-radius: 100px;background: red;color: white;"></span></a>
                      </template>
                    </v-list-item>
                    <v-list-item>
                      <template v-slot:append>
                        <a @click="gotoInstagram()" id="testbutton2" style="width: 154px;"
                          class="btn btn-md btn-info testbutton">اینستاگرام روبو<i style="margin-left:5px" class="fa-brands fa-instagram"></i></a>

                      </template>
                    </v-list-item>
                    <v-list-item>
                      <template v-slot:append>
                        <a @click="this.isModalPishnahad = true" id="testbutton2" style="width: 154px;"
                          class="btn btn-md btn-info testbutton">ثبت پیشنهاد<i style="margin-left:5px" class="fa-regular fa-star"></i></a>

                      </template>
                    </v-list-item>
                    <v-list-item>
                      <template v-slot:append>
                        <a @click="logout()" style="width: 154px;" class="btn btn-md btn-danger">خروج</a>

                      </template>
                    </v-list-item>


                  </v-list>

                </v-card>
              </v-theme-provider>
            </v-menu>


          </div>
        </div>
      </div>
      <router-view v-on:getuserData="getuserData()" v-on:showReferral="showReferral()" v-on:setCredit="setCredit()"
        v-on:setCredit1="setCredit1()" v-on:showCredit="isModalVisible = true"
        :class="isModalReferral == true || isModalVisible == true || isModalPishnahad == true ?  'custom' : ''" />
      <notifications position="bottom center" />
      <div :class="isModalReferral == true || isModalVisible == true || isModalPishnahad == true ? 'custom' : ''"
        v-if="isMobile == true && ($route.path == '/imagegeneration' || $route.path == '/' || $route.path == '/Gallery' || $route.path == '/characters' || $route.path == '/conversations')"
        class="mobileBottomNav_xZSxG" style="border-radius: 20px 20px 0 0;">
        <button @click="goto('/')" class="p-component tu-button btn-tertiary navItem_1fNF2" type="button">
          <span class="tu-btn-content" tabindex="-1">
            <!---->
            <i class="fa-solid fa-home" :style="$route.path == '/' ? 'color: #6153cc;' : ''"
              style="font-size:20px;margin-bottom:7px;margin-top:5px"></i>
            <div style="font-size:13px;">خانه</div>
          </span>
        </button>
        <button @click="goto('/conversations')" class="p-component tu-button btn-tertiary navItem_1fNF2" type="button">
          <span class="tu-btn-content" tabindex="-1">
            <!---->
            <i :class="$route.path == '/conversations' ? 'fa-solid' : 'fa-regular'" class="fa-message"
              :style="$route.path == '/conversations' ? 'color: #6153cc;' : ''"
              style="font-size:20px;margin-bottom:7px;margin-top:5px"></i>
            <div style="font-size:13px;">گفتگو ها</div>
          </span>
        </button>
        <button @click="goto('/imagegeneration')" class="p-component tu-button btn-tertiary navItem_1fNF2" type="button">
          <span class="tu-btn-content" tabindex="-1">
            <!---->
            <i class="fa-regular fa-image" :style="$route.path == '/imagegeneration' ? 'color: #6153cc;' : ''"
              style="font-size:20px;margin-bottom:7px;margin-top:5px"></i>
            <div style="font-size:13px;">عکس</div>
          </span>
        </button>
        <button @click="goto('/Gallery')" class="p-component tu-button btn-tertiary navItem_1fNF2" type="button">
          <span class="tu-btn-content" tabindex="-1">
            <!---->
            <i class="fa-regular fa-images" :style="$route.path == '/Gallery' ? 'color: #6153cc;' : ''"
              style="font-size:20px;margin-bottom:7px;margin-top:5px"></i>
            <div style="font-size:13px;">گالری</div>
          </span>
        </button>
        <button @click="goto('/characters')" class="p-component tu-button btn-tertiary navItem_1fNF2" type="button">
          <span class="tu-btn-content" tabindex="-1">
            <!---->
            <i class="fa-solid fa-users" :style="$route.path == '/characters' ? 'color: #6153cc;' : ''"
              style="font-size:20px;margin-bottom:7px;margin-top:5px"></i>
            <div style="font-size:13px;">شخصیت ها</div>
          </span>
        </button>
      </div>
      <div v-if="isModalReferral || this.userInfo.showModalReferral" class="login-box">
        <div class="basket">
          <div style="overflow: auto;
    max-height: 70vh;" class="purchaseSuccess mx-2 my-4 px-3 py-2 rounded-2 bg-cff6e9 position-relative">
            <h5 class="mb-4 title fw-bold pt-2" style="font-size:20px">دعوت دوستان</h5>
            <p style="white-space: pre-line;
      padding: 0;
      color: #fff;
      text-align: right;" class="font-12 text">با دعوت دوستان خود به روبو هم شما و هم دوستتان<br> 50 کوکی 🍪 دریافت
              میکنید</p>
            <p style="white-space: pre-line;
      padding: 0;
      color: #fff;
      text-align: right;" class="font-12 text">کافیه فقط کد خودتونو به دوستتون بدید و هنگام ثبت نام کد شمارو وارد کنه
            </p>
            <button v-if="isApplication" @click="shareCode()" type="submit" class="text-white btn btn-primary w-100"
              style="margin-bottom: 7px;">ارسال دعوتنامه
              <i id="menubar" class="fa-solid fa-share-from-square"></i>
            </button>
            <button type="submit" class="text-white btn btn-primary w-100" style="margin-bottom: 7px;"
              v-clipboard:copy="this.Referral"> کد دعوت: {{ this.Referral }}
              <i id="menubar" class="fa-solid fa-copy"></i>
            </button>
            <button type="submit" class="text-white btn btn-info w-100" style="margin-bottom: 7px;">تعداد دعوت شده: {{
              this.invites.length }}</button>
            <div class="d-flex flex-column" v-for="(item, index) in invites" :key="index">
              <a type="submit" style="margin-bottom: 7px; text-align:center"
                class="text-white btn btn-info btn-md w-100">{{ item }}</a>
            </div>

            <div style="margin-top:25px;margin-bottom: 5px;" class="d-flex justify-content-between">
              <button @click="this.isModalReferral = false" type="submit"
                class="text-white btn btn-danger w-100">بستن</button>
            </div>
          </div> <!----><!---->
        </div>
      </div>
      <div v-if="isModalPishnahad" class="login-box">
        <div class="basket">
          <div style="overflow: auto;
    max-height: 70vh;" class="purchaseSuccess mx-2 my-4 px-3 py-2 rounded-2 bg-cff6e9 position-relative">
            <h5 class="mb-4 title fw-bold pt-2" style="font-size:20px">ثبت پیشنهاد</h5>
            <p style="white-space: pre-line;
      padding: 0;
      color: #fff;
      text-align: center;" class="font-12 text">{{ this.name }} عزیز نظرت برای ما مهمه!</p>
            <div class="text-button">
              <textarea autoresize autocomplete="off" type="text" autofocus="" id="textarea-input" v-model="chatbox"
                style="padding:10px;text-align: start;unicode-bidi: plaintext;overflow-y: auto;resize: none;width:100%;height:100%;min-height:110px;line-height:25px;display:block;font-size:17px;font-family: IRANSansWeb;color:white;outline: none;"
                placeholder="📝 پیشنهاد شما..." />
            </div>
            <div style="margin-top:10px;margin-bottom: 5px;" class="d-flex justify-content-between">
              <button @click="sendSuggestion()" type="submit" class="text-white btn btn-primary w-100">ارسال</button>
            </div>
            <div style="margin-top:10px;margin-bottom: 5px;" class="d-flex justify-content-between">
              <button @click="this.isModalPishnahad = false" type="submit"
                class="text-white btn btn-danger w-100">بستن</button>
            </div>
          </div> <!----><!---->
        </div>
      </div>
      <div v-if="isModalVisible" class="login-box">
        <div class="basket" style="padding:20px;">
          <div style="display:flex;justify-content: space-between;">
            <span style="font-size: 20px;color:white">بسته های کوکی شما</span>
            <i @click="isModalVisible = false" class="fa-solid fa-x"
              style="margin-top:5px;font-size: 20px;color:white"></i>
          </div>
          <div style="margin-top:30px;">
            <div @click="showReferral()"
              style="display:flex;justify-content: space-between;border-radius: 10px;padding:20px;background-color: #5d62c6;">
              <span style="margin-top:20px;font-size: 1em;font-weight:bold;color:white">دوستاتو دعوت کن<br>50 کوکی🍪
                بگیر</span>
              <img :src="require('@/assets/img/invite1.png')" style="width:150px;height:100px">
            </div>
            <div v-if="this.credit == 0"
              style="margin-top:20px;background-color: #212529; padding:10px;border-radius: 10px;">
              <div style="display:flex;padding:5px;margin-bottom:-5px;justify-content: space-between;">
                <img :src="require('@/assets/img/gift.png')" style="padding:5px;margin-top:-5px;width:60px;height:60px">
                <div style="display: grid;">
                  <span style="font-size: 18px;font-weight:bold;color:white">روزانه رایگان</span>
                  <span style="font-size: 13px;color:white">معتبر تا ساعت 00:00</span>
                </div>
                <div style="margin-top:12px;">
                  <span style="font-size: 18px;font-weight:bold;color:white">{{ this.userInfo.credit }} از 5</span>
                </div>
                <div>
                </div>
              </div>
            </div>
            <div v-if="this.credit > 0 && this.credit < 1000"
              style="margin-top:20px;background-color: #212529; padding:10px;border-radius: 10px;">
              <div style="display:flex;padding:5px;margin-bottom:-5px;justify-content: space-between;">
                <img :src="require('@/assets/img/cookiejar.jpg')" style="margin-top:-5px;width:60px;height:60px">
                <div style="display: grid;">
                  <span style="font-size: 18px;font-weight:bold;color:white">جعبه کوکی🍪</span>
                  <span style="font-size: 13px;color:white">معتبر تا {{ this.engheza }}</span>
                </div>
                <div style="margin-top:12px;">
                  <span style="font-size: 18px;font-weight:bold;color:white">{{ this.userInfo.credit }} از 500</span>
                </div>
                <div>
                </div>
              </div>
            </div>
            <div v-if="this.credit > 10000"
              style="margin-top:20px;background-color: #212529; padding:10px;border-radius: 10px;">
              <div style="display:flex;padding:5px;margin-bottom:-5px;justify-content: space-between;">
                <img :src="require('@/assets/img/unlimitedcookie.jpg')" style="margin-top:-5px;width:60px;height:60px">
                <div style="display: grid;">
                  <span style="font-size: 18px;font-weight:bold;color:white">معدن کوکی🍪</span>
                  <span style="font-size: 13px;color:white">معتبر تا {{ this.engheza }}</span>
                </div>
                <div style="margin-top:12px;">
                  <span style="font-size: 18px;font-weight:bold;color:white">نامحدود</span>
                </div>
                <div>
                </div>
              </div>
            </div>

            <div @click="goto('/packages')"
              style="margin-top:30px;text-align:center;padding:5px;border-radius: 5px;background-color: #E23E57;color:white;font-weight: bold;font-size:20px">
              <i style="padding: 10px;color:white" class="fa-solid fa-shopping-basket"></i>همین حالا خرید کنید!</div>
          </div>
        </div>
      </div>


    </div>
  </div>
</template>
<script>
import router from './router';
import axios from 'axios';
import { notify } from "@kyvg/vue3-notification";
/* eslint-disable */

export default {

  data() {
    return {
      isPoshtibani:false,
      raminname: "ramin",
      mobile: '',
      value: 1,
      credit: 0,
      promotionDate:null,
      intervalId:null,
      engheza: '',
      invites: [],
      name: '',
      chatbox: '',
      showPromotion:false,
      isModalPishnahad: false,
      freeCredit: 0,
      showCookie: false,
      Referral: '',
      isModalVisible: false,
      isModalReferral: false,
      isApplication: navigator.userAgent.match(/ir.roboo.pwa/i) ? true : false,
      isMobile: navigator.userAgent.match(/Android/i)
        || navigator.userAgent.match(/webOS/i)
        || navigator.userAgent.match(/iPhone/i)
        || navigator.userAgent.match(/iPad/i)
        || navigator.userAgent.match(/iPod/i)
        || navigator.userAgent.match(/BlackBerry/i)
        || navigator.userAgent.match(/Windows Phone/i) ? true : false,
    }
  },
  methods: {
    gotoInstagram()
    {
      if(this.isApplication == true)
      Android.Download("https://www.instagram.com/roboo.ir");
      else
      window.open("https://www.instagram.com/roboo.ir");
    },
    gotoPromotion()
    {
      router.push("/promotion");
    },
    sendSuggestion() {
      if(this.chatbox != "")
      {
      let json =
      {
        token: localStorage.getItem("token"),
        comment: this.chatbox,
        subject: "pishnahad"
      }
      axios.post("https://api3.roboo.ir/api/Suggestion/AddSuggestion", json).then((response) => {
        if (response.data.status == 0) {
          this.chatbox = "",
          this.isModalPishnahad = false;
            notify({
              title: "پیشنهادات",
              text: response.data.message,
              type: "success"
            });
        }
        else
  {
    notify({
      title: "خطا",
      text: response.data.message,
      type: "error"
    });
  }
      });
    }
    else
    {
      notify({
              title: "پیشنهادات",
              text: "متن پیشنهادی شما خالی است!",
              type: "error"
            });
    }
    },
    logout() {
      localStorage.setItem('token', "");
      router.push('login');
    },
    shareCode() {
      var text = "دوست گرامی، شما از طرف «" + this.name + "» عزیز به اپلیکیشن روبو دعوت شده اید." + "\nروی لینک زیر کلیک کرده و اپلیکیشن روبو را نصب کنید تا با پیشرفته ترین هوش مصنوعی ایرانی در موضوعات مختلف گفتگو کرده یا عکس دلخواهتان را بسازید." +
        "\nکد «" + this.Referral + "» را در قسمت کد معرف وارد کنید و 50 اعتبار رایگان، هدیه بگیرید." + "\nhttps://roboo.ir\n روبو پیشرفته ترین ربات هوش مصنوعی چت و عکس ایرانی";
      // eslint-disable-next-line
      Android.ShareText(text);
    },
    setCredit() {
      this.showCookie = false;
      this.showCookie = true;
      if (this.userInfo.credit <= 0) {
        this.getuserData();
      }
    },
    setCredit1() {
      this.showCookie = false;
      this.showCookie = true;
    },
    showReferral() {
      this.isModalVisible = false;
      this.isModalReferral = true;
    },
    goto(route) {
      if (this.isModalVisible == true)
        this.isModalVisible = false;
      router.push(route);
    },
    showPoshtibani() {
      Goftino.open()
    },
    getuserData() {
      //this.chats=[];
      this.history = [];
      axios.get("https://api3.roboo.ir/api/Users/GetUserDataC?token=" + localStorage.getItem("token"))
        .then(response => {
          if (response.data.status == 0) {
            this.mobile = response.data.mobile;
            this.name = response.data.name;
            this.credit = response.data.credit;
            this.freeCredit = response.data.freeCredit;
            this.engheza = response.data.packageEndDate;
            this.invites = response.data.referrals;
            this.Referral = response.data.referral;
            this.userInfo.mobile = this.mobile;
            this.userInfo.credit = this.credit == 0 ? response.data.freeCredit : this.credit;
            this.userInfo.engheza = this.engheza;
            this.userInfo.Referral = this.Referral;
            this.userInfo.invites = this.invites;
            this.showCookie = false;
            this.showCookie = true;
            if(this.isApplication)
            {
                Android.setToken(localStorage.getItem("token"));
            }
            // if (element2.length > 0) {
            //   window.$crisp.push(["set", "session:data", [[
            //     ["user-credit", this.credit.toString()],
            //     ["user-expire", this.engheza.toString()],
            //     ["user-invites", this.invites.length.toString()],
            //     ["user-mobile", this.mobile.toString()]
            //   ]]]);
            // }
            // else {
            //   setTimeout(() => {
            //     window.$crisp.push(["set", "session:data", [[
            //       ["user-credit", this.credit.toString()],
            //       ["user-expire", this.engheza.toString()],
            //       ["user-invites", this.invites.length.toString()],
            //       ["user-mobile", this.mobile.toString()]
            //     ]]]);
            //   }, 3000);
            // }
          }
          else {
            //NotSuccess
            router.push("login");
          }
        }).catch(function (error) {
          console.log(error);
          console.log(error.code);
          if (!error.response) {
            router.push("/game");
            // network error (server is down or no internet)
          } else {
            // http status code
            console.log(error.response.status)
            // data from server while error
            console.log(error.response.data)
          }
        });
    },
    gotoPackages() {
      router.push("/packages");
    },
    test() {
      let element = document.getElementById('menubar');
      if (element != null) {
        element.classList.toggle('fa-bars');
        element.classList.toggle('fa-x');
      }
    },
  },
  mounted() {
  
    if(this.isMobile == false)
    {
      window.location = "https://newpanel.roboo.ir"
    }
    var token = localStorage.getItem("token");
    if (token != null && token != "") {
      this.getuserData();
      const config = { headers: {'Content-Type': 'application/json'} };
      axios.post("https://localhost:44389/api/Users/UserDate",localStorage.getItem("token"),config).then(response=>{
        if(response.data == "3" && localStorage.getItem("promotionDate") == null && this.credit < 70)
            {
              var date = new Date();
              //date.setTime(date.getTime() + 1000 * 60);
              date.setDate(date.getDate() + 1);
              localStorage.setItem("promotionDate",date);
              router.push("/promotion");
            }
      });
    }
    else {
      var onboarding = localStorage.getItem("onboarding");
      if (onboarding == null) {
        localStorage.setItem("onboarding", "true");
        router.push("/onboarding");
      }
      else
        router.push("/login");
    }
    if (this.isMobile) {
      document.getElementsByClassName('v-overlay-container')[0].onclick = function (e) {
        if (e.target != document.getElementById('menuu')) {
          let element = document.getElementById('menubar');
          if (element != null) {
            element.classList.add('fa-bars');
            element.classList.remove('fa-x');
          }
        }
      }
      document.getElementById('app').onclick = function (e) {
        if (e.target != document.getElementById('menuu')) {
          let element = document.getElementById('menubar');
          if (element != null) {
            element.classList.add('fa-bars');
            element.classList.remove('fa-x');
          }

        }

      }
    }
    //Goftino
    var that = this;
    !function(){var i="de2QR2",a=window,d=document;function g(){var g=d.createElement("script"),s="https://www.goftino.com/widget/"+i,l=localStorage.getItem("goftino_"+i);g.async=!0,g.src=l?s+"?o="+l:s;d.getElementsByTagName("head")[0].appendChild(g);}"complete"===d.readyState?g():a.attachEvent?a.attachEvent("onload",g):a.addEventListener("load",g,!1);}();
    window.addEventListener('goftino_ready', function () {
        Goftino.setWidget({
                hasIcon: false,
                counter: '#unread_message'
            });
            setTimeout(()=>{
            Goftino.setUser({
            name : that.name,
            about : that.credit+" | "+that.engheza,
            phone : that.mobile,
            forceUpdate : true
          });
        },5000);
    });
    window.addEventListener('goftino_getMessage', function (d) {
if(that.isPoshtibani == false)
{
var message_type = d.detail.type;
// "text" , "file" , "voice" , "question"
var message_content = d.detail.content;
notify({
              title: "پشتیبانی آنلاین",
              text: "پیام جدید: "+message_content,
              type: "info"
            });
          }
});
window.addEventListener('goftino_openWidget', function () {
    that.isPoshtibani = true;
});
window.addEventListener('goftino_closeWidget', function () {
  that.isPoshtibani = false;
});


function updateTimer() {
  var timer = document.getElementById("timer");
  if(timer == null)
  {
    //clearInterval(that.intervalId);
    return;
  }
  var future  = that.promotionDate;
  var now     = new Date();
  var diff    = future - now;

  var days  = Math.floor( diff / (1000*60*60*24) );
  var hours = Math.floor( diff / (1000*60*60) );
  var mins  = Math.floor( diff / (1000*60) );
  var secs  = Math.floor( diff / 1000 );

  var h = hours - days  * 24;
  var m = mins  - hours * 60;
 var  s = secs  - mins  * 60;

  timer.innerText =
     h + ':' +m + ':' +s;

     if(h == 0 && m == 0 && s == 1)
     that.showPromotion = false;

}
var promotion = localStorage.getItem("promotionDate");
var nowDate = new Date();
if(promotion != null && Date.parse(promotion) > nowDate)
{
  this.promotionDate = Date.parse(promotion);
  this.showPromotion = true;
  updateTimer();
  this.intervalId = setInterval(updateTimer,1000);
}
//localStorage.removeItem("promotionDate");
  }
}
/* eslint-disable */

// window.open = function (open) {
//   return function (url, name, features) {
//     // set name if missing here
//     name = name || "default_window_name";
//     return open.call(window, url, name, features);
//   };
// }(window.open);
</script>
<style scoped>

@import url('@/assets/topnav.css');
#unread_message:empty {
    display: none;
}
@font-face {
  font-family: IRANSansWeb;
  src: url('./assets/IRANSansWeb.woff2') format("woff2");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: IRANSansWeb;
  src: url('./assets/IRANSansWebBold.woff2') format("woff2");
  font-weight: bold;
  font-style: normal;
}

body {
  background-color: #212529;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.text-button {
  backdrop-filter: blur(3px);
  background-color: rgb(41, 41, 41);
  border-radius: 15px;
  box-shadow: 2px 2px 2px rgba(black, 0.1);
  cursor: pointer;

}

.login-box {
  top: 50%;
  left: 50%;
  position: fixed;
  width: 90vw;
  padding: 10px;
  transform: translate(-50%, -50%);
  z-index: 10000;
  background-color: rgb(24, 24, 24);
  box-sizing: border-box;
  box-shadow: 0 15px 25px rgba(0, 0, 0, .6);
  border-radius: 10px;

}

.custom {
  filter: blur(5px);
}
</style>